import React, { useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Button, TextField, Stack, Alert,
} from '@mui/material';

export default function ChangePasswordDialog({ open, forced, onSuccess, onCancel }) {
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (newPassword !== confirm) { setError('Neue Passwörter stimmen nicht überein.'); return; }
    if (newPassword.length < 8) { setError('Passwort muss mindestens 8 Zeichen haben.'); return; }
    setLoading(true);
    try {
      const res = await fetch('/api/auth/password', {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ currentPassword, newPassword }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.message || 'Fehler beim Ändern.'); setLoading(false); return; }
      setCurrentPassword(''); setNewPassword(''); setConfirm('');
      onSuccess(data);
    } catch { setError('Netzwerkfehler.'); setLoading(false); }
  };

  return (
    <Dialog open={open} onClose={forced ? undefined : onCancel} fullWidth maxWidth="xs">
      <DialogTitle>{forced ? 'Erstmaliges Passwort setzen' : 'Passwort ändern'}</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          {forced && (
            <Alert severity="warning" sx={{ mb: 2 }}>
              Du musst ein neues Passwort setzen, bevor du fortfahren kannst.
            </Alert>
          )}
          <Stack spacing={2}>
            <TextField label="Aktuelles Passwort" type="password" value={currentPassword}
              onChange={e => setCurrentPassword(e.target.value)} fullWidth required autoComplete="current-password" />
            <TextField label="Neues Passwort" type="password" value={newPassword}
              onChange={e => setNewPassword(e.target.value)} fullWidth required autoComplete="new-password"
              helperText="Mindestens 8 Zeichen" />
            <TextField label="Neues Passwort bestätigen" type="password" value={confirm}
              onChange={e => setConfirm(e.target.value)} fullWidth required autoComplete="new-password" />
            {error && <Alert severity="error">{error}</Alert>}
          </Stack>
        </DialogContent>
        <DialogActions>
          {!forced && <Button onClick={onCancel} color="inherit">Abbrechen</Button>}
          <Button type="submit" variant="contained" disabled={loading}>
            {loading ? 'Speichern…' : 'Passwort ändern'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
